import React from 'react';

import CatalogoEstadosSeguimiento from './CatalogoEstadosSeguimiento';
import { getEstadoSeguimientoSin, tablaEstadoSeguimientoSin } from '../../../querys/EstadosSeguimiento';
import { addEstadoSeguimientoSin, updateEstadoSeguimientoSin, deleteEstadoSeguimientoSin } from '../../../mutations/EstadosSeguimiento';

function EstadosSeguimientoSiniestros() {
    return <CatalogoEstadosSeguimiento
        titulo="Estados de Seguimiento Siniestros"
        asyncGet={getEstadoSeguimientoSin}
        asyncTabla={tablaEstadoSeguimientoSin}
        asyncAdd={addEstadoSeguimientoSin}
        asyncUpdate={updateEstadoSeguimientoSin}
        asyncDelete={deleteEstadoSeguimientoSin}
    />;
}

export default EstadosSeguimientoSiniestros;
